import { HttpClient } from '@angular/common/http';
import {BaseService} from './base.service';
import { Observable} from 'rxjs';


export class BasecrudService extends BaseService {
  protected _baseUrl: string;

  constructor(http: HttpClient, baseUrl:string) {
    super(http);
    this._baseUrl = baseUrl;
  }

  GetAll(): Observable<any[]>{
    return this.GetValue<any[]>(this._baseUrl);
  }
  GetItem(id):any{
    return this.GetValue(this._baseUrl +  '/getbyid/' + id);
  }

  Inserir(item){
    return this.PostValue(this._baseUrl,item)
  }
  Atualizar(item){
    return this.PutValue(this._baseUrl,item);
  }

  GetWFilter(filter){
    var obj = {
      custonFilter: filter
    };
    return this.PostValue(this._baseUrl + '/getwfilter',obj);
  }

  Excluir(id: string):any{
    return this.DeleteValue(this._baseUrl +'?id='+id);
  }


}
